import { render, staticRenderFns } from "./templateProducts.vue?vue&type=template&id=793b8966&scoped=true"
import script from "./templateProducts.vue?vue&type=script&lang=js"
export * from "./templateProducts.vue?vue&type=script&lang=js"
import style0 from "./templateProducts.vue?vue&type=style&index=0&id=793b8966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b8966",
  null
  
)

export default component.exports